import { BoardColumn, Lead, ProspectStatus } from "../models/Lead";
import api from "./api";

// ---- Leads (funil / board) ----

export const getBoard = async (): Promise<BoardColumn[]> => {
  try {
    const response = await api.get(`/api/prospect/board`);
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const saveLead = async (lead: Lead) => {
  try {
    const response = await api.post(`/api/prospect`, lead);
    if (!response.data.success) {
      console.log("error", response.data);
    }
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateLead = async (lead: Lead) => {
  try {
    const response = await api.put(`/api/prospect/${lead.id}`, lead);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const moveLead = async (
  id: string,
  move: { prospectStatusId?: string | null; order: number }
) => {
  try {
    const response = await api.put(`/api/prospect/${id}/move`, move);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteLead = async (id: string) => {
  try {
    const response = await api.delete(`/api/prospect/${id}`);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const getLeadById = async (id: string): Promise<Lead | undefined> => {
  try {
    const response = await api.get(`/api/prospect/${id}`);
    return response.data;
  } catch (error) {
    console.log("error", error);
  }
};

// ---- Status (colunas do funil) ----

export const getStatuses = async (): Promise<ProspectStatus[]> => {
  try {
    const response = await api.get(`/api/prospectStatus`);
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const saveStatus = async (status: ProspectStatus) => {
  try {
    const response = await api.post(`/api/prospectStatus`, status);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const updateStatus = async (status: ProspectStatus) => {
  try {
    const response = await api.put(`/api/prospectStatus/${status.id}`, status);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteStatus = async (id: string) => {
  try {
    const response = await api.delete(`/api/prospectStatus/${id}`);
    return response;
  } catch (error) {
    console.log("error", error);
  }
};
